module.exports = __webpack_public_path__ + "img/contents_market@2x.b812231c.png";